export default __webpack_public_path__ + "static/media/person (2).85c5c487.png";